<template>
  <div>
    <van-swipe class="banner" indicator-color="white" :autoplay="banner.rotationRate" :loop="banner.rotation">
      <van-swipe-item v-for="(item, index) in banner.banners" :key="index">
        <img class="banner-img" :src="item.image" />
      </van-swipe-item>
    </van-swipe>
    <div class="img-wrapper">
      <img src="https://ysh-cdn.kaidicloud.com/test/ecology/partner-1.png" class="content-image-1" />
    </div>
    <div class="wrapper">
      <img src="https://ysh-cdn.kaidicloud.com/test/ecology/partner-3.png" class="content-image-2" />
      <div class="info-box">
        <div class="cell-box">
          <div class="cell-title">姓名：</div>
          <input class="cell-input" v-model="form.name" type="span" maxlength="20" placeholder="请输入姓名" placeholder-class="cell-placeholder" />
        </div>
        <div class="cell-box">
          <div class="cell-title">手机号：</div>
          <input class="cell-input " v-model="form.phoneNum" type="number" maxlength="11" placeholder="请输入手机号" placeholder-class="cell-placeholder" />
        </div>
        <div class="cell-box">
          <div class="cell-title">企业：</div>
          <input class="cell-input" v-model="form.companyName" type="span" maxlength="50" placeholder="请输入企业" placeholder-class="cell-placeholder" />
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="btn" @click="submit">马上提交</div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { getBanners, recruitment } from '@/api/data'
import { Swipe, SwipeItem, Toast } from 'vant'
import { sendClickLog } from '@/api/srd'
Vue.use(Swipe).use(SwipeItem)
export default {
  components: {
    [Swipe.name]: Swipe,
    [Toast.name]: Toast
  },
  data() {
    return {
      form: {
        name: '',
        phoneNum: '',
        companyName: '',
        source: ''
      },
      banner: {
        banners: [],
        rotation: true,
        rotationRate: 3000
      }
    }
  },
  mounted() {
    this.form.name = this.$route.query.name || ''
    this.form.phoneNum = this.$route.query.phoneNum || ''
    this.form.source = this.$route.query.source || ''
    this.getBanner()
    this.$route.meta.title = '生态合作伙伴招募'
    document.title = this.$route.meta.title
  },
  methods: {
    async getBanner() {
      const {
        data: { data }
      } = await getBanners()
      this.banner = data
    },
    async submit() {
      try {
        const {
          data: { msg }
        } = await recruitment(this.form)
        Toast({
          message: `<div style="min-width: 96px;padding:6px 8px;font-size:16px;line-height:1.6;">${msg}</div>`,
          type: 'html'
        })
      } catch (error) {}
      this.sendClickSubmitEvent()
    },
    sendClickSubmitEvent() {
      sendClickLog({
        function: 'T152',
        current_url: window.location.origin+window.location.pathname
      })
    }
  }
}
</script>
<style lang="less">
.nav {
  height: 108px;
  width: 750px;
  display: flex;
  align-items: center;
  padding-left: 32px;
  position: relative;
  .header-background {
    position: absolute;
    z-index: -1;
    width: 750px;
    left: 0;
  }
}
.nav-back {
  width: 20px;
  height: 36px;
}

.nav .nav-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 36px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #222222;
  line-height: 50px;
}
.img-wrapper,
.wrapper {
  img {
    width: 100%;
  }
}
.wrapper {
  position: relative;
}
.info-box {
  position: absolute;
  top: 630px;
  left: 56px;
  .cell-box{
    line-height: 68px;
  }
  .cell-title {
    width: 610px;
    height: 48px;
    font-size: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 48px;
    margin-top: 12px;
  }
  .cell-input {
    border: none;
    background: transparent;
    font-size: 28px;
    border-bottom: 2px #eee solid;
    line-height: 44px;
    color: #333333;
  }
}
.footer {
  bottom: 0;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  background: #fff;
  width: 100%;
  height: calc(140px + env(safe-area-inset-bottom));
  z-index: 10;
  margin: 0 auto;
  display: flex;
  position: fixed;
  justify-content: center;
  align-items: center;
  .btn {
    width: 686px;
    height: 88px;
    background: #872ff9;
    border-radius: 44px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    color: #ffffff;
    line-height: 88px;
  }
}
.banner {
  flex-shrink: 0;
  width: 750px;
  height: 344px;
  padding: 20px 32px 0;
  border-radius: 24px 24px 0px 0px;
  box-sizing: border-box;
  z-index: 10;
  background: white;
}

.banner .banner-img {
  width: 694px;
  height: 324px;
  background: #d8d8d8;
  border-radius: 12px;
}
</style>
